/* Yup validation schemas goes here */

import i18n from "i18n";
import * as yup from "yup";

export const EMAIL_MAX_LENGTH = 100;
export const EMPLOYEE_ID_MAX_LENGTH = 30;
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const employeeSearchFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(30, i18n.t("employeeSearch.firstNameLengthError")),
  lastName: yup.string().max(30, i18n.t("employeeSearch.LastNameLengthError")),
  employeeId: yup
    .string()
    .max(
      EMPLOYEE_ID_MAX_LENGTH,
      i18n.t("employeeSearch.employeeIdLengthError")
    )
});

/** Email is validated on blur / Find only (not on every keystroke). */
export const getEmailFieldError = (value) => {
  if (!value) {
    return undefined;
  }
  if (value.length > EMAIL_MAX_LENGTH) {
    return i18n.t("employeeSearch.emailLengthError");
  }
  if (!EMAIL_FORMAT.test(value)) {
    return i18n.t("employeeSearch.emailFormatError");
  }
  return undefined;
};
